<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="home-swiper" v-if="bannerList.length">
      <ISwiper :imgList="bannerList"></ISwiper>
    </div>
    <!-- 设备筛选 -->
    <section class="home-filter container">
      <div class="change_box">
        <div class="filter">
          <div class="filter-left">类型</div>
          <div class="filter-right">
            <span :class="[typeId == item.id ? 'selectItem' : 'selected-item']" v-for="item in typeList" :key="item.id" @click="numSelect(item.id, 'type')">{{ item.name }}</span>
          </div>
        </div>
        <div class="filter">
          <div class="filter-left">品牌</div>
          <div class="filter-right">
            <span :class="[brandId == item.id ? 'selectItem' : 'selected-item']" v-for="item in brandList" :key="item.id" @click="numSelect(item.id, 'brand')">{{ item.brandName }}</span>
          </div>
        </div>
        <div class="filter">
          <div class="filter-left">区域</div>
          <div class="filter-right">
            <span :class="[areaId == item.code ? 'selectItem' : 'selected-item']" v-for="item in $optionsData.provinceList" :key="item.code" @click="numSelect(item.code, 'area')">{{ item.text }}</span>
          </div>
        </div>
        <div class="filter" v-for="item in attrsList" :key="item.title">
          <div class="filter-left">{{ item.title }}</div>
          <div class="filter-right">
            <span :class="[val.checked ? 'selectItem' : 'selected-item']" v-for="(val, index) in item.options" :key="val.value" @click="selectTem(item.title, index)">{{ val.name }}</span>
          </div>
        </div>
      </div>
    </section>
    <!-- 设备列表 -->
    <section class="equipment-list container">
      <template v-if="equipmentList.length">
        <div class="equipment-item" v-for="(item, index) in equipmentList" :key="index" @click="toEquipmentDetail(item.crmEquipmentId)">
          <el-image class="info-img" fit="cover" :src="item.thumbnail" lazy></el-image>
          <div class="info-bottom">
            <div class="info-title">{{ item.title }}</div>
            <div class="info-year">{{ item.subHeading }}</div>
            <div class="info-tag">
              <p v-for="val in item.targerList" :key="val">{{ val }}</p>
            </div>
            <div class="info-price">
			  <div class="priceContent" v-if="item.crmEquipmentFixedPriceId && item.offlineBargaining != 1">
                <p>{{ item.startingPrice / 1000000 }}</p>
                <p>万</p>
              </div>
              <p style="font-size: 16px" v-else>价格面议</p>
              <img class="qrCode" fit="cover" src="@/assets/img/ewm2.png" @click.stop="showQRCode(item.crmEquipmentId, item.crmEquipmentFixedPriceId)" />
            </div>
          </div>
        </div>
      </template>
      <div class="no-data" v-else>
        <div class="no-pic">
          <img class="pic-empty" src="@/assets/img/pic-empty.png" alt="" />
          <p>暂无符合条件的车源</p>
        </div>
        <p class="help-car" @click="handleSelect">帮我找车</p>
      </div>
    </section>
    <!-- 分页器 -->
    <section class="container">
      <TablePage ref="list" @page-change="getEquipmentList" :total="total" :pageSizeNum="pageSizeNum"> </TablePage>
    </section>
    <!-- 生成设备菊花码 -->
    <el-dialog width="320px" :visible.sync="dialogVisible" @close="closeDialog">
	  <div class="dialogContent">
        <el-image fit="contain" class="qrCodeImg" v-loading="paintLoading" :src="qrcodeUrl" />
      </div>
      <div class="qrCodeText">扫描二维码手机查看该设备的详情<br />更多在售设备等待您的到来~</div>
    </el-dialog>
    <!-- 侧边栏服务 -->
    <Dangling />
  </div>
</template>

<script>
import ISwiper from "@/components/ISwiper.vue";
import TablePage from "@/components/TablePage";
import Dangling from "@/components/Dangling";
export default {
  name: "Home",
  data() {
    return {
      total: 0,
      pageSizeNum: 20,
      bannerList: [], //轮播列表
      equipmentList: [], //设备列表
      typeId: 47, //设备类型-筛选
      brandId: "", //设备品牌-筛选
      areaId: "", //区域-筛选
      typeList: [], //设备类型列表
      brandList: [], //设备品牌列表
      attrsList: [], //筛选模板列表
      tonnageName: "", //吨位筛选
      yearsName: "", //年限筛选
      workingHoursName: "", //小时数筛选
      batchNumName: "", //批量数筛选
      armSpanName: "", //臂展长度筛选
      // 小程序二维码弹层展示控制参数
      dialogVisible: false,
      paintLoading: false,
      qrcodeUrl: "", //小程序码
    };
  },
  props: {},
  computed: {},
  components: { ISwiper, TablePage, Dangling },
  async mounted() {
    if (sessionStorage.getItem("msgInfo")) {
      let data = JSON.parse(sessionStorage.getItem("searchCondition"));
      this.typeId = data[0].typeId;
      this.brandId = data[0].brandId;
      this.areaId = data[0].areaId;
      this.tonnageName = data[0].tonnageName;
      this.yearsName = data[0].yearsName;
      this.workingHoursName = data[0].workingHoursName;
      this.batchNumName = data[0].batchNumName;
      this.armSpanName = data[0].armSpanName;
      this.attrsList = data[1];
    } else {
      sessionStorage.removeItem("searchCondition");
      this.getSearchConfig();
    }
    this.getBannerList();
    this.getMachineType();
    this.getMachineBrand();
    this.searchHandler();
  },
  destroyed() {
    sessionStorage.removeItem("msgInfo");
  },
  methods: {
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    async getBannerList() {
      try {
        let res = await this.$api.bannerList();
        this.bannerList = res.data || [];
      } catch (error) {
        console.log(error);
      }
    },
    numSelect(val, type) {
      if (type == "type") {
        this.typeId = val;
        this.onReset();
        this.getMachineBrand();
        this.getSearchConfig();
        sessionStorage.removeItem("msgInfo");
      } else if (type == "brand") {
        this.brandId = this.brandId != val ? val : "";
      } else if (type == "area") {
        this.areaId = this.areaId != val ? val : "";
      }
      this.getEquipmentList(1, 20);
    },
    selectTem(title, index) {
      let list = this.attrsList;
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].options.length; j++) {
          if (list[i].title == title) {
            if (j == index) {
              if (list[i].options[j].checked == true) {
                list[i].options[j].checked = false;
                if (title == "出厂年限") {
                  this.yearsName = "";
                } else if (title == "表显小时数") {
                  this.workingHoursName = "";
                } else if (title == "吨位" || title == "起重总量") {
                  this.tonnageName = "";
                } else if (title == "批量数") {
                  this.batchNumName = "";
                } else if (title == "臂架长度") {
                  this.armSpanName = "";
                }
              } else {
                list[i].options[j].checked = true;
                if (title == "出厂年限") {
                  this.yearsName = list[i].options[j].value;
                } else if (title == "表显小时数") {
                  this.workingHoursName = list[i].options[j].value;
                } else if (title == "吨位" || title == "起重总量") {
                  this.tonnageName = list[i].options[j].value;
                } else if (title == "批量数") {
                  this.batchNumName = list[i].options[j].value;
                } else if (title == "臂架长度") {
                  this.armSpanName = list[i].options[j].value;
                }
              }
            } else {
              list[i].options[j].checked = false;
            }
          }
        }
      }
      this.attrsList = list;
      this.$forceUpdate();
      this.getEquipmentList(1, 20);
    },
    onReset() {
      this.brandId = "";
      this.areaId = "";
      this.tonnageName = "";
      this.yearsName = "";
      this.workingHoursName = "";
      this.batchNumName = "";
      this.armSpanName = "";
    },
    async getMachineType() {
      try {
        let res = await this.$api.machineType();
        this.typeList = res.data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getMachineBrand() {
      try {
        let res = await this.$api.machineBrand({ typeId: this.typeId || 47 });
        this.brandList = res.data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getSearchConfig() {
      try {
        let res = await this.$api.searchConfig({ typeId: this.typeId || 47 });
        this.attrsList = res.data && res.data.cardList ? res.data.cardList[0].attrs : [];
      } catch (error) {
        console.log(error);
      }
    },
    async getEquipmentList(page, pageSize) {
      const params = {
        pageNo: page,
        pageSize: pageSize,
        search: {
          typeId: this.typeId,
          brandId: this.brandId,
          provinceCodes: [this.areaId || 100000],
          tonnageName: this.tonnageName,
          yearsName: this.yearsName,
          workingHoursName: this.workingHoursName,
          batchNumName: this.batchNumName,
          armSpanName: this.armSpanName,
        },
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.equipmentList(params);
        this.equipmentList = list.map((item) => {
          let targerList = this.$optionsData.parseLabel(item);
          if (targerList.indexOf("寄售") != -1) {
            targerList.splice(targerList.indexOf("寄售"), 1);
          }
          targerList = targerList.splice(0, 2);
          item["targerList"] = targerList;
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
    toEquipmentDetail(id) {
      this.$router.push(`/home/equipment-detail?id=${id}`);
      let storageData = {
        typeId: this.typeId,
        brandId: this.brandId,
        areaId: this.areaId,
        tonnageName: this.tonnageName,
        yearsName: this.yearsName,
        workingHoursName: this.workingHoursName,
        batchNumName: this.batchNumName,
        armSpanName: this.armSpanName,
      };
      sessionStorage.setItem("searchCondition", JSON.stringify([storageData, this.attrsList])); //存储搜索条件
    },
    handleSelect() {
      this.$router.push("/find-car");
    },
    async showQRCode(id, crmEquipmentFixedPriceId) {
      this.paintLoading = true;
      this.qrcodeUrl = "";
      let res = await this.$api.getPosterInfo({ equipmentId: id }); //获取生成海报信息
      this.qrCode(id, res.data.auctionInfo, crmEquipmentFixedPriceId);
    },
    async qrCode(id, auctionInfo, priceId) {
      let params = {};
      if (priceId) {
        params = {
          appId: "wx4b0ed890669a0359",
          page: "pages/priceDetail/index",
          scene: `${id};${priceId};false`,
          url: "sfile-yl.sany.com.cn", //"sfile-yltest.sany.com.cn"、"sfile-yl.sany.com.cn"
          width: "96",
          // env_version: "trial",
        };
      } else {
        params = {
          appId: "wx4b0ed890669a0359",
          page: "pages/equipmentDetail/index",
          scene: auctionInfo ? `${id};true` : `${id};false`,
          url: "sfile-yl.sany.com.cn", //"sfile-yltest.sany.com.cn"、"sfile-yl.sany.com.cn"
          width: "96",
          // env_version: "trial",
        };
      }
      let resCode = await this.$api.getVxCode({ ...params }); //获取微信小程序二维码
      this.qrcodeUrl = resCode.data;
      this.dialogVisible = true;
      this.paintLoading = false;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.paintLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  .home-swiper {
    width: 100%;
    height: 100%;
    padding-top: 30px;
  }
  .home-filter {
    height: 100%;
    background: #f6f7f9;
    margin-top: 30px;
    .change_box {
      padding: 0 20px;
      box-sizing: border-box;
      .filter {
        padding: 10px 0;
        border-bottom: 1px solid #efeff4;
        display: flex;
        align-items: center;
        .filter-left {
          width: 70px;
          font-size: 14px;
          font-weight: 500;
          color: #999999;
          padding-right: 24px;
          border-right: 1px solid #efeff4;
          flex: none;
        }
        .filter-right {
          display: flex;
          flex-flow: wrap;
          .selectItem {
            padding: 8px 10px;
            font-size: 14px;
            font-weight: 500;
            color: #fb463f;
            background: rgba(251, 70, 63, 0.08);
            margin-right: 10px;
            border-radius: 4px;
            cursor: pointer;
          }
          .selected-item {
            padding: 8px 10px;
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            margin-right: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .equipment-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 100%;
    margin-top: 30px;
    .equipment-item {
      width: 290px;
      height: 100%;
      margin-bottom: 30px;
      cursor: pointer;
      .info-img {
        width: 290px;
        height: 190px;
        display: block;
      }
      .info-bottom {
        width: 100%;
        height: 110px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        box-sizing: border-box;
        .info-title {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .info-year {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
        .info-tag {
          display: flex;
          align-items: center;
          p {
            height: 18px;
            line-height: 18px;
            padding: 2px 5px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 400;
            color: #fb463f;
            background: rgba(251, 70, 63, 0.08);
            margin-right: 5px;
          }
        }
        .info-price {
          display: flex;
          align-items: flex-end;
          flex-direction: row;
          justify-content: space-between;
		  .priceContent {
			  display: flex;
			  flex-direction: row;
			  align-items: flex-end;
		  }
          p {
            color: #fb463f;
            &:nth-child(1) {
              font-weight: 500;
              font-size: 22px;
            }
            &:nth-child(2) {
              font-weight: 400;
              font-size: 14px;
              line-height: 18px;
              margin-left: 2px;
            }
          }
          .qrCode {
            height: 25px;
            width: 25px;
          }
        }
      }
      &:last-child:nth-child(4n - 1) {
        margin-right: calc(24% + 4% / 3);
      }
      &:last-child:nth-child(4n - 2) {
        margin-right: calc(48% + 8% / 3);
      }
      &:hover {
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
      }
    }
    .no-data {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .no-pic {
        .pic-empty {
          width: 300px;
          height: 197px;
        }
        p {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          line-height: 18px;
          margin-top: 10px;
          text-align: center;
        }
      }
      .help-car {
        width: 140px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #fb463f;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin-top: 30px;
        cursor: pointer;
      }
    }
  }
  .qrCodeImg {
    width: 300px;
    height: 300px;
  }
  .qrCodeText {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    line-height: 1.5;
  }
  .dialogContent {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
